import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class LogisticsVehicleMultiSelectListCtrl implements IController {

  selectedIds: string[];
  disabledIds: string[];
  ngPlaceholder: any;
  isStandAlone: boolean;
  vehicleTypes: VehicleType[];
  branchIds: string[];
  onChange: Function;

  private logisticsVehiclesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: string;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $logisticsVehicle, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.logisticsVehiclesRef = this.$logisticsVehicle();
    this.loadLimit = 20;

    if (!this.selectedIds) {
      this.selectedIds = []
    }
    this.logisticsVehiclesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.logisticsVehiclesRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(logisticVehicleId, isSelected) {
    this.onChange({
      logisticsVehicleIds: isSelected ? _.concat(this.selectedIds || [], [logisticVehicleId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== logisticVehicleId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({logisticsVehicleIds: []});
    } else {
      this.onChange({logisticsVehicleIds: this.infiniteScroll?.getItems()?.map((logisticVehicle) => logisticVehicle.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(logisticVehicle => logisticVehicle.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.logisticsVehiclesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      isStandAlone: this.isStandAlone,
      vehicleTypes: this.vehicleTypes,
      branchIds: this.branchIds,
      sort: 'name,asc'
    };
  }

}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleMultiSelectList', {
    bindings: {
      selectedIds: '<',
      disabledIds: '<?',
      ngPlaceholder: '@?',
      isStandAlone: '<?',
      vehicleTypes: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./logistics-vehicle-multi-select-list.html').default,
    controller: LogisticsVehicleMultiSelectListCtrl
  });
